import React from 'react';
import { connect } from 'react-redux';
import AutoBookingModal from '../../components/Modals/AutoBookingModal';
import SavePromptModal from '../../components/Modals/SavePromptModal';
import { DAYS, MODALS } from '../../constants';
import { getAddIntervalError } from '../../selectors/autobooking';
import { getActiveModal } from '../../selectors/common';

const mapToProps = (state) => ({
  activeModal: getActiveModal(state),
  addIntervalError: getAddIntervalError(state),
});

const AutoBookingModals = (props) => {
  const modalDataSavePrompt = {
    title: 'Do you want to save the changes?',
    additionalMessages: [],
  };
  switch (props.activeModal) {
    case MODALS.AUTO_BOOKING:
      return (
        <AutoBookingModal
          leagues={props.leagues}
          closeModal={props.closeIntervalModal}
          addInterval={props.addInterval}
          addIntervalError={props.addIntervalError}
          modalData={props.modalData}
          isTennis={props.isTennis}
        />
      );
    case MODALS.DELETE_INTERVAL:
      return (
        <SavePromptModal
          modalData={{
            title: 'Are you sure you want to remove interval:',
            additionalMessages: [
              `${DAYS[props.modalData.selectedInterval.startDay]
                .slice(0, 3)} ${props.modalData.selectedInterval.startTime}
                      -
                      ${DAYS[props.modalData.selectedInterval.endDay]
          .slice(0, 3)} ${props.modalData.selectedInterval.endTime}`,
            ],
          }}
          cancel={props.closeIntervalModal}
          confirmation={props.handleRemoveInterval
            .bind(this, props.modalData.interval.id)}
          confirm="Confirm"
          cancelled="Cancel"
        />
      );

    case MODALS.SAVE_INTERVAL:
      return (
        <SavePromptModal
          modalData={modalDataSavePrompt}
          additionalInfo="Your changes will be lost if you don't save them"
          cancel={props.closeIntervalModal}
          confirmation={props.saveChanges.bind(this, {
            intervals: props.intervals,
          })}
          confirm="Save"
          cancelled="Cancel"
        />
      );

    case MODALS.SAVE_BEFORE_NAVIGATION:
      return (
        <SavePromptModal
          modalData={modalDataSavePrompt}
          additionalInfo="Your changes will be lost if you don't save them"
          cancel={props.forceNavigateWithoutSave}
          confirmation={props.saveChanges.bind(this, {
            intervals: props.intervals,
          })}
          confirm="Save"
          cancelled="Don't Save"
        />
      );

    default:
      return null;
  }
};

export default connect(mapToProps)(AutoBookingModals);
